import { defineStore } from 'pinia'

export const useInspectSsInfoStore = defineStore('inspectSsInfoStore', {
  state: () => ({
    inspectSsInfo: null
  })
})
